import { createGlobalStyle } from 'styled-components';
import { breakpoint, mobileSize } from './ThemeStyle';

const GlobalStyle = createGlobalStyle`
  @import url('https://fonts.googleapis.com/css?family=Noto+Sans');
    body {
      font-family: Noto Sans KR, sans-serif;
      margin: 0;
      box-sizing: border-box;
      background-color: #ffffff;
      overflow-x: hidden ;
    }

    * {
      box-sizing: inherit;
      font-size: ${`calc(16px*${breakpoint}/${mobileSize})`};

      @media screen and (max-width: ${breakpoint}px) {
        font-size:${`calc(1600vmin/${mobileSize})`}
      };
    }

    a {
      text-decoration: inherit;
      color: inherit;
    }

    input{
      border: none;
      outline: none;
    };

    input:-webkit-autofill {
   -webkit-box-shadow: 0 0 0 1000px #FFF inset;
}
`;

export default GlobalStyle;
